import SeoFlightResultWrapper from '@/src/components/desktop/srp/flightSchedule/seoFlightResult'
import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'

const FlightSchedulePage = () => {
    return (
        <ErrorBoundaryWrapper identifier="flightSchedule-desktop-srp">
            <SeoFlightResultWrapper />
        </ErrorBoundaryWrapper>
    )
}

export default FlightSchedulePage
